var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{ref:_vm.name,staticStyle:{"display":"none"},attrs:{"action":_vm.formAction,"method":"post","name":_vm.name}},[_c('input',{attrs:{"name":"_method","type":"hidden","value":"POST"}})]),_vm._v(" "),_c('a',{class:_vm.linkClass,attrs:{"href":"#/"},on:{"click":_vm.submit}},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62b4616d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Utility/Buttons/PostLink.vue
// module id = 770
// module chunks = 0 1